module.exports = __webpack_public_path__ + "static/media/slide9.8f90213f.png";